import { Component, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { Tab } from 'src/app/components/tabs/tabs.component';
import { DashboardService } from 'src/app/dashboard/services/dashboard.service';
import { ItineraryService } from 'src/app/search-result/services/itinerary.service';
import { ReRouteService } from 'src/app/re-route/services/re-route.service';
import { InvoluntaryChangeService } from 'src/app/involuntary-change/services/involuntary-change.service';
import {
  Passenger,
  PassengerQuote,
  PnrInfo,
  SearchForm
} from 'src/app/core/models/itinerary.model';
import {
  IReRouteModalQuote,
  IReRoutePassengerData,
  IReRouteQuoteRequest
} from 'src/app/core/models/re-route.model';

@Component({
  selector: 'app-re-route-layout',
  templateUrl: './re-route-layout.component.html',
  styleUrls: ['./re-route-layout.component.scss']
})
export class ReRouteLayoutComponent implements OnDestroy {
  loading$: Observable<boolean>;
  isError$: Observable<boolean>;
  selectedPassengers$: Observable<Passenger[]>;

  subscriptions = new Subscription();

  searchForm: SearchForm;
  pnrInfo: PnrInfo;
  modalQuote: IReRouteModalQuote;
  selectedPassengersQuote: PassengerQuote[] = [];
  selectedPassengersSplitQuote: PassengerQuote[] = [];
  reRoutePassengerData: IReRoutePassengerData[] = [];
  reRouteQuoteRequest: IReRouteQuoteRequest;
  typeTabs: Tab[] = [{ name: 'voluntary-change.passengers' }];
  splitIsNecesary = false;

  constructor(
    private itineraryService: ItineraryService,
    private dashboardService: DashboardService,
    private reRouteService: ReRouteService,
    private involChangeService: InvoluntaryChangeService
  ) {
    this.itineraryService.dispatchChooseActionMode('reRoute');
    this.dashboardService.getSearchForm().subscribe((searchForm) => {
      this.searchForm = searchForm;
    });
    this.loading$ = this.reRouteService.getLoading();
    this.isError$ = this.reRouteService.getIsError();
    this.involChangeService.dispatchResetSplitState();
    this.buildAndSaveSelectedPassengers();
  }

  buildAndSaveSelectedPassengers() {
    this.selectedPassengers$ = this.reRouteService.getSelectedPassengers();

    this.subscriptions.add(
      this.itineraryService.getPnrInfo().subscribe((pnrInfo) => {
        this.pnrInfo = pnrInfo;

        this.reRouteService.getModalQuote().subscribe((modalQuote) => {
          this.modalQuote = modalQuote;

          this.fillReRoutePassengerData();
        });
      })
    );
  }

  fillReRoutePassengerData() {
    this.itineraryService.getSelectedPassengersQuote().subscribe((passengersQuote) => {
      this.validateIfSplitIsNecesary(passengersQuote?.length);
      this.selectedPassengersSplitQuote = passengersQuote;
      this.selectedPassengersQuote = [];

      if (passengersQuote) {
        passengersQuote.forEach((passenger) => {
          const index = this.pnrInfo.passengers.findIndex(
            (passengerPNR) => passengerPNR.id === passenger.id
          );
          if (index > -1) {
            this.selectedPassengersQuote.push(
              this.pnrInfo.passengers[index] as unknown as PassengerQuote
            );
            this.reRoutePassengerData.push({
              id: passenger.id,
              ticketNumber: passenger.ticketNumber,
              passengerType: passenger.passengerType
            });
          }
        });

        this.reRouteService.dispatchSaveSelectedPassengers(
          this.selectedPassengersQuote as unknown as Passenger[]
        );
        this.buildAndSaveReRouteQuoteRequest();
      }
    });
  }

  validateIfSplitIsNecesary(selectedPassengersNumber: number) {
    if (selectedPassengersNumber) {
      if (this.pnrInfo.passengers.length > selectedPassengersNumber) {
        this.splitIsNecesary = true;
      } else {
        this.splitIsNecesary = false;
      }
    } else {
      this.splitIsNecesary = false;
    }
  }

  buildAndSaveReRouteQuoteRequest() {
    this.reRouteQuoteRequest = {
      segments: this.pnrInfo.itinerary.segments,
      waiver: this.modalQuote?.waiver,
      tourCode: this.modalQuote?.tourCode,
      osis: this.modalQuote?.osis,
      overSign: this.modalQuote?.overSign,
      pnr: this.pnrInfo.code,
      country: this.pnrInfo.countryCode,
      gds: this.pnrInfo.gds,
      receivedFrom: this.reRouteQuoteRequest?.receivedFrom,
      bookingCode: this.searchForm.bookingCode,
      transactionId: this.pnrInfo.transactionId,
      officeId: this.pnrInfo.officeId,
      passengers: this.reRoutePassengerData,
      docsa: null
    };

    this.reRouteService.dispatchSaveReRouteQuoterequest(this.reRouteQuoteRequest);
  }

  backToItinerary() {
    this.dashboardService.dispatchSubmitSearch(this.searchForm);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
